import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { ResponseData } from "../../nest-responses";

@Injectable()
export class BasePhotoApi {
  private readonly service: string = '';
  private readonly model: string = 'base-photo';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getBasePhoto() {
    const method: string = 'GET';
    const func: string = '';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, func, params, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-all-in-one/services/base-photo.api.ts